import {
  ErrorBoundary,
  ModalContainer,
  ThemeProvider,
  useTheme
} from '@convergence/components';
import '@convergence/components/dist/components.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { PostHogProvider } from 'posthog-js/react';
import { ToastContainer } from 'react-toastify';
import { queryClient } from '../api/query-client';
import { AuthProvider } from '../components/AuthProvider';
import { PopoverProvider } from '../components/Popover';
import { Telemetry } from '../lib/Telemetry';

const ToastContainerWrapper = () => {
  const theme = useTheme();

  return <ToastContainer theme={theme.darkMode ? 'dark' : 'light'} />;
};

export function Providers(props: { children: React.ReactNode }) {
  return (
    <Telemetry.Provider>
      <ErrorBoundary>
        <ModalContainer>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <ThemeProvider>
                <PopoverProvider>{props.children}</PopoverProvider>
              </ThemeProvider>
            </AuthProvider>
          </QueryClientProvider>
        </ModalContainer>
        <ToastContainerWrapper />
      </ErrorBoundary>
    </Telemetry.Provider>
  );
}
